import { useNavigate, useLocation } from 'react-router-dom';
import { DEMO2_MANIFEST } from '../demo2Routes';

export default function Demo2Nav() {
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname;

    const current =
        DEMO2_MANIFEST.find(m =>
            path.startsWith(m.path.split('/').slice(0, 4).join('/')),
        ) ?? DEMO2_MANIFEST.find(m => m.path === path);
    const group = path.includes('/demo2/mobile') ? 'MOBILE' : 'WEB';

    return (
        <div className="sian">
            <div className="sian-demo-nav">
                <a
                    className="sdn-brand"
                    onClick={() => navigate('/demo2/web/dashboard')}
                    style={{ cursor: 'pointer' }}
                >
                    <span className="m">🌳</span>
                    <span>
                        <em>AIS</em>×수프로
                    </span>
                </a>
                <span className="sdn-tag">수목관리 시스템</span>
                <span className="sdn-crumb">
                    {current ? (
                        <>
                            {current.group} · <strong>{current.title}</strong>
                        </>
                    ) : null}
                </span>
                <span className="sdn-spacer" />
                <span className="sdn-mode-btn">
                    <a
                        className={group === 'WEB' ? 'active' : ''}
                        onClick={() => navigate('/demo2/web/login')}
                        style={{ cursor: 'pointer' }}
                    >
                        WEB
                    </a>
                    <a
                        className={group === 'MOBILE' ? 'active' : ''}
                        onClick={() => navigate('/demo2/mobile/login')}
                        style={{ cursor: 'pointer' }}
                    >
                        MOBILE
                    </a>
                </span>
                <span className="sdn-select-wrap">
                    <select
                        className="sdn-select"
                        value={current?.path ?? ''}
                        onChange={e => navigate(e.target.value)}
                    >
                        {DEMO2_MANIFEST.map(m => (
                            <option key={m.key} value={m.path}>
                                {m.group === 'WEB' ? '🖥️ WEB' : '📱 MOBILE'} ·{' '}
                                {m.ico} {m.title}
                            </option>
                        ))}
                    </select>
                </span>
            </div>
        </div>
    );
}
